import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { HEIGHT_ITEM } from '../../const';
import { RootState } from '../../store';
import { getExpandedItems } from '../../table/functions';
import { ItemType, MappingItemIdIndexType } from '../../types';

export const useGantOperationalHeight = () => {
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const newItems = useMemo(() => getExpandedItems(itemsList, mappingItemIdIndex), [itemsList]);

    return newItems.length * HEIGHT_ITEM + 1;
};
